/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface XpMultiplier
 */
export interface XpMultiplier {
    /**
     * 
     * @type {string}
     * @memberof XpMultiplier
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof XpMultiplier
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof XpMultiplier
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof XpMultiplier
     */
    expiresAt: number;
}

export function XpMultiplierFromJSON(json: any): XpMultiplier {
    return XpMultiplierFromJSONTyped(json, false);
}

export function XpMultiplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): XpMultiplier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'amount': json['amount'],
        'createdAt': json['createdAt'],
        'expiresAt': json['expiresAt'],
    };
}

export function XpMultiplierToJSON(value?: XpMultiplier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'amount': value.amount,
        'createdAt': value.createdAt,
        'expiresAt': value.expiresAt,
    };
}


